<template>
  <BLayout :colors="$site.colors" :notice="false">
    <div class="-mt-14 sm:mt-8">
      <ServiceElementDetails :id="route.params.id" />
    </div>
  </BLayout>
</template>

<script setup lang="ts">
const route = useRoute()
</script>
